// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/gift.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/gift'

import { Icon, type IconComponentProps } from '../icon'

export const GiftIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
